import { render, staticRenderFns } from "./DTPCreate.vue?vue&type=template&id=06cb052e&"
import script from "./DTPCreate.vue?vue&type=script&lang=js&"
export * from "./DTPCreate.vue?vue&type=script&lang=js&"
import style0 from "./DTPCreate.vue?vue&type=style&index=0&id=06cb052e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports